export default __webpack_public_path__ + "static/media/expenses.be6ae0ee.svg";